import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { ListItem } from "@src/types/ota-update";
import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";

export const getFirmwares = async (
  namespace: string,
  sourceId: string,
  signal?: AbortSignal,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<ListItem[]>(
      `${url}/api/v1/ns/${namespace}/firmwares`,
      {
        headers,
        params: {
          source_id: sourceId,
        },
        signal,
      },
    );

    return response;
  } catch (err) {
    if (signal?.aborted) return;
    else if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch firmwares. Please try again later.",
      );
    } else {
      throw new Error("An unexpected error occurred while fetching firmwares.");
    }
  }
};
